import React, { useEffect, useState } from "react";
import MainBg from "../components/Mainbg";
import Banner3 from "../assets/images/dasboard/banner3.png";
import Drawer from "react-modern-drawer";
import GymView from "./Sidebar/GymView";
import { useDispatch, useSelector } from "react-redux";
import {
  refreshToken2,
  setDrawerActiveMenu,
  setIsDrawerActive,
} from "../store/features/webUtilitiesSlice";
// import workout_data from "../ApiResponse/workout.json";
import secureLocalStorage from "react-secure-storage";
import gymloader from "../assets/images/loaders/gymloader.png";
import axios from "axios";
import { GET_GYM_ENDPOINT } from "../config/ApisCollection";
import { useNavigate } from "react-router-dom";

const GYM = () => {
  const [isDrawerPopupOpen, setDrawerPopupOpen] = useState(false);
  const [workoutChoosedData, setWorkoutChoosedData] = useState(null);
  const [workout_data, set_workout_data] = useState([]);
  const dispatch = useDispatch();
  const accessToken = secureLocalStorage.getItem("accessToken");
  let history = useNavigate();

  const handleChangeSidebar = async (menu) => {
    await dispatch(setDrawerActiveMenu(menu));
    await dispatch(setIsDrawerActive(true));
  };

  const getGoodReadData = async () => {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0]; // Format date as YYYY-MM-DD
    const formattedTime = currentDate.toTimeString().split(" ")[0]; // Format time as HH:MM:SS
    const request_body = {
      headers: {
        Authorization: "Bearer " + accessToken,
        CDate: formattedDate,
        CTime: formattedTime,
        "Content-Type": "application/json",
      },
      body: {},
    };

    await axios
      .get(GET_GYM_ENDPOINT, request_body)
      .then((response) => {
        if (response && response.data) {
          setTimeout(() => {
            set_workout_data(Object.entries(response.data));
          }, 2000);
        }
      })
      .catch((error) => {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.message &&
          error.response.data.error.message === "token expired" &&
          secureLocalStorage.getItem("refreshToken")
        ) {
          dispatch(refreshToken2());
        } else if (error?.response?.data?.error?.message === "token expired") {
          secureLocalStorage.clear();
          history("/login");
        }
      });
  };

  useEffect(() => {
    getGoodReadData();
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <MainBg>
        {workout_data?.length == 0 && (
          <>
            <img src={gymloader} className="h-72 m-auto" />
            <h1 className="text-center mt-10">loading....</h1>
          </>
        )}
        <div className="grid xl:grid-cols-3 lg:grid-cols-3 sm:grid-cols-1 grid-cols-1 sm:gap-20 md:py-20 mb-20">
          <div className="sm:col-span-2 col-span-1 lg:px-10 px-0 sm:border-r-2 border-none">
            {/* <div className="">
              <input
                type="text"
                className="w-full border-2 border-gray-350 p-2 rounded-lg"
                placeholder="↻ Search workouts..."
              />
            </div> */}
            <div>
              {workout_data.length > 0 &&
                workout_data[6][1]?.map((cl_row, index) => (
                  <div key={index}>
                    <div className="mt-10">
                      <h1 className="font-bold">
                        {cl_row.title.toUpperCase()}
                      </h1>
                    </div>
                    <div className="mt-2 grid xl:grid-cols-5 lg:grid-cols-5  sm:grid-cols-3 md:grid-cols-4  xs:grid-cols-1 grid-cols-2 gap-5 ">
                      {cl_row.data.map((wl_row, index) =>
                        wl_row.name === wl_row.name ? (
                          <div
                            className="melasbox cursor-pointer hover:bg-[#ffede0]"
                            onClick={() => {
                              // setDrawerPopupOpen(true);
                              // setWorkoutChoosedData(wl_row);
                              history("/gym/gym-view", { state: wl_row });
                            }}
                            key={index}
                          >
                            <div>
                              <img
                                loading="lazy"
                                src={wl_row.imageUrl}
                                alt={wl_row?.name?.slice(0, 20)}
                                className="mealsimg h-[121px]"
                                height={145}
                                width={120}
                              />
                            </div>
                            <div className="melalin">
                              <div className="modesutit text-capitalize">
                                {wl_row.duration} min
                              </div>
                              <div className="tabetsbol text-capitalize text-[10px]">
                                {wl_row?.name?.slice(0, 20)}
                              </div>
                              <hr />
                              <div className="fastiweekboxtit">
                                {wl_row.repetition + " routines"}{" "}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <span key={index}></span>
                        )
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </div>
          <div className="flex sm:flex-row flex-col justify-center sm:justify-start xl:fixed sm:right-0 ">
            <div className="">
              {workout_data.length > 0 ? (
                <div className="cardbox xl:w-3/4  w-full bg-cover bg-center px-0">
                  <div className="mode1">
                    <img className="watchImg" alt="watchImg" src={Banner3} />
                    <div>
                      <p className="cardboxtitle text-base">
                        {workout_data[0][1]}
                      </p>
                      <p className="text-xs">{workout_data[1][1]}</p>
                      <button
                        className="mt-2 light-orgn-btn rounded-lg text-[11px]"
                        onClick={() => {
                          history("/gym/explore/workoutexplore");
                        }}
                      >
                        {workout_data[4][1]}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}

              {workout_data.length > 0 ? (
                <div className="xl:w-3/4 w-full mt-10">
                  <div className="fasweekdes">
                    <div className="mode1">
                      <div className="tabroe">
                        <div className="modetit text-lg">Targeted workout</div>
                      </div>
                    </div>
                  </div>

                  <div className="fasweekdes">
                    {workout_data.length > 0 &&
                      workout_data[3][1].map((tp_row, index) =>
                        index < 4 ? (
                          <div
                            className="melasbox cursor-pointer"
                            key={index}
                            onClick={() => {
                              history("/gym/explore/" + tp_row.categoryvalue);
                            }}
                          >
                            <div className="relative">
                              <img
                                loading="lazy"
                                src={tp_row.image}
                                alt={tp_row?.categoryvalue?.toUpperCase()}
                                className="h-[70px] w-[70px]"
                              />
                              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-[10px] text-center text-white">
                                {tp_row?.categoryvalue?.toUpperCase()}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <></>
                        )
                      )}
                  </div>
                </div>
              ) : (
                <></>
              )}

              {workout_data.length > 0 ? (
                <div className="fastiweekbox xl:w-3/4 w-full">
                  <div className="fastiweekboxtit text-sm font-semibold">
                    Your workout streak
                  </div>

                  <div className="fasweekdes mb-5">
                    {workout_data.length > 0 &&
                      workout_data[5][1].track.map((fs_row, index) => (
                        <div className="tabroe" key={index}>
                          <img
                            loading="lazy"
                            src={fs_row.img}
                            alt="fireac"
                            className="w-6"
                          />
                          <div className="fastiweekboxtext text-xs mt-1 font-medium">
                            {fs_row?.day?.slice(0, 3)}
                          </div>
                        </div>
                      ))}
                  </div>

                  <div className="text-xs font-medium text-center">
                    <span className="">{workout_data[5][1]?.trackResult} </span>
                    {/* <span className="">You’re </span>
                    <span className="text-[#fe7701]"> 40% more likely</span>
                    <span className=""> to achieve your goal</span> */}
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </MainBg>

      <Drawer
        open={isDrawerPopupOpen}
        direction="right"
        lockBackgroundScroll={false}
        className={`manlay !p-5 !pb-10 sm:!w-96 !w-80 !overflow-y-scroll !overflow-x-hidden !rounded-l-3xl !border-none`}
        onClose={() => {
          setDrawerPopupOpen(false);
        }}
      >
        {/* {console.log(workoutChoosedData)} */}
        <GymView workoutChoosedData={workoutChoosedData} />
      </Drawer>
    </>
  );
};
export default GYM;
